<template lang="pug">
  v-content
    v-dialog(v-model='creationModal', fullscreen='', transition='dialog-bottom-transition')
      CreateDialog
    //Tutorials
    vue-draggable-resizable(v-if="dialogTutorial" :w="350" :h="250" :minHeight="250" :minWidth="150" :maxHeight="390" :maxWidth="768" :z="9999" :parent="true" style="border: none")
      v-card(style="height: 100%")
        v-card-title
          v-spacer
          v-icon(@click="closeDialog('tutorialDialog')")
            | mdi-close
        v-card-text(style="height: 90%")
          iframe#FrameID(:src="tutorialVideo" width="100%" height="100%" frameborder="0").ma-auto
    router-view
    // dashboard-core-footer(v-if="$route.name === 'Dashboard'")

</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
      CreateDialog: () => import('@/components/custom/dialogs/CreateDialog'),
    },
    computed: {
      isAuth () {
        return !!this.$store.state.users.user
      },
      currentDialog () {
        return this.$store.getters['dialogs/getCurrentItem']
      },
      creationModal () {
        return this.$store.getters['dialogs/getCreateDialog']
      },
      dialogTutorial () {
        return this.$store.state.dialogs.tutorial
      },
      tutorialVideo () {
        return this.$store.state.dialogs.tutorialVideo
      },
    },
    methods: {
      closeDialog (dialog) {
        this.$store.dispatch('dialogs/closeDialog', dialog).then(function () {

        })
      },
    },
  }
</script>
